import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WindowScrollService } from './core/services/window-scroll.service';
import { WindowResizeService } from './core/services/window-resize.service';
import { VisibilityService } from './core/services/visibility.service';
import { NotificationComponent } from './core/components/notification/notification.component';
import { PageLoaderComponent } from './core/components/page-loader/page-loader.component';

@Component({
    selector: '#app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [
        RouterOutlet,
        NotificationComponent,
        PageLoaderComponent
    ],
})
export class AppComponent {
    public constructor(
        private readonly windowScrollService: WindowScrollService,
        private readonly windowResizeService: WindowResizeService,
        private readonly visibilityService: VisibilityService
    ) {
        this.windowScrollService.setScroll(window.scrollY);
        this.windowResizeService.setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    @HostListener('window:scroll', ['$event'])
    public onScroll(): void {
        this.windowScrollService.setScroll(window.scrollY);
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.windowScrollService.setScroll(window.scrollY);
        this.windowResizeService.setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    @HostListener('window:visibilitychange', ['$event'])
    public onWindowVisible(): void {
        this.visibilityService.setWindowVisible(!document.hidden);
    }
}
